__turbopack_context__.v({
  "ProgramHighlights__cardContainer": "CampusEmersion-module-scss-module__4HaBVq__ProgramHighlights__cardContainer",
  "ProgramHighlights__subtitle": "CampusEmersion-module-scss-module__4HaBVq__ProgramHighlights__subtitle",
  "ProgramHighlights__textContainer": "CampusEmersion-module-scss-module__4HaBVq__ProgramHighlights__textContainer",
  "ProgramHighlights__title": "CampusEmersion-module-scss-module__4HaBVq__ProgramHighlights__title",
  "root": "CampusEmersion-module-scss-module__4HaBVq__root",
  "swiper-button-next": "CampusEmersion-module-scss-module__4HaBVq__swiper-button-next",
  "swiperButtonNext": "CampusEmersion-module-scss-module__4HaBVq__swiperButtonNext",
  "swiperButtonPrev": "CampusEmersion-module-scss-module__4HaBVq__swiperButtonPrev",
});
